import { Col } from 'react-bootstrap';
import styled from 'styled-components';
import FormFieldset from 'components/forms/form/FormFieldset';
import LinkWithIcon from 'pages/property/common/LinkWithIcon';

export const NonRefundableRateDiscountContainer = styled(Col)`
  padding-right: 0;

  .form-field-container {
    margin-left: -15px;
    margin-top: -25px;
  }
`;

export const ViewAirbnbResolutionsStyled = styled(LinkWithIcon)`
  align-self: flex-end;
  width: fit-content;
  margin-top: 15px;
`;

export const OpenSetInstructionsContainer = styled(Col)`
  margin-bottom: 10px;
  margin-top: -15px;

  button {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const SetInstructionsFieldsetStyled = styled(FormFieldset)`
  display: flex;
  flex-direction: column;

  .form-field-container > div {
    width: 100%;
  }

  textarea {
    resize: vertical;
  }
`;
